// export const DOMAIN = "http://localhost:4000"; // hoặc domain thật
// export const DOMAIN = "https://api.elephant.friend.zvshsuddhdndnmxmx4.fun"; //4
// export const DOMAIN = "https://api.elephant.bro.zvshsuddhdndnmxmx4.fun"; //3y
// export const DOMAIN = "https://api.elephant.nam.zvshsuddhdndnmxmx4.fun"; //2
export const DOMAIN = "https://api.elephant.zvshsuddhdndnmxmx4.fun"; //1
// export const DOMAIN = "https://api.old.zvshsuddhdndnmxmx4.fun"; //0


export const DOMAIN_FB = `${DOMAIN}/api/fb/`;